import Grid from "@mui/material/Grid";
import SelectBusinessAccount from "../../../Meta/SelectBusinessAccount";
import {
  ACTIVE,
  ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL,
  ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE,
  ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE,
  APP_PLACEHOLDER,
  BUTTON_CANCEL,
  BUTTON_CONTINUE,
  CATALOG_PLACEHOLDER,
  DAILY_BUDGET_PLACEHOLDER,
  DEACTIVATED,
  FIELD_REQUIRED,
  INSTAGRAM_ACCOUNT_PLACEHOLDER,
  OPTIONAL,
  IOS_14_CAMPAIGN_PLACEHOLDER,
  IS_CATALOG_CAMPAIGN_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  OBJECTIVE_PLACEHOLDER,
  PAGE_FACEBOOK_PLACEHOLDER,
  TYPE_BUDGET_PLACEHOLDER,
  USE_CAMPAIGN_BUDGET_PLACEHOLDER,
  BUYING_TYPE_PLACEHOLDER,
  CHANGE_BUYING_TYPE_TO_RESERVED_TITLE,
  CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import { Controller, useFormContext } from "react-hook-form";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import {
  AD_ACCOUNT_PLATFORMS_LABELS,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION,
  FONT_FAMILY,
  META,
  metaCurrenciesWithDecimals,
  ADS_CAMPAIGN_BUYING_TYPE_AUCTION_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED,
} from "../../../../utils/constants";
import AutocompleteField from "../../../Form/AutocompleteField";
import { hasInstagramAccountsConnected } from "../../../../utils/meta";
import SelectPageFacebook from "../../../Meta/SelectPageFacebook";
import SelectInstagramAccount from "../../../Meta/SelectInstagramAccount";
import Select from "../../../Form/Select";
import {
  optionsAdsCampaignObjectivesMeta,
  optionsAdsCampaignSpecialAdCategoriesMeta,
  optionsAdsCampaignTypeBudgets,
  optionsBuyingType,
} from "../../../../utils/options";
import ReasoningContainer from "../../../../pages/NewAdsCampaign/components/Common/ReasoningContainer";
import { ConfirmAlert } from "../../../Alerts/Alerts";
import Typography from "@mui/material/Typography";
import NumberDecimalField from "../../../Form/NumberDecimalField";
import NumberField from "../../../Form/NumberField";
import { getCurrencyAdAccountPlatform } from "../../../../actions/getters";
import { useDispatchApp, useSelectorApp } from "../../../../lib/redux";
import TextField from "../../../Form/TextField";
import Switch from "../../../Form/Switch";
import SelectCatalogMeta from "./SelectCatalogMeta";
import SelectAdvertisableAppsMeta from "../Ad/SelectAdvertisableAppsMeta";
import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import CardContainer from "../../../Card/CardContainer";
import { startGetCurrencyTax } from "../../../../actions/adsCampaigns";
import {
  clampIntegerMetaBudgetPercent,
  metaBudgetAmountFromIntegerPercent,
} from "../../../../utils/numbers";
import { clearMetaReusableCreativeModeFromAds } from "../../../../utils/metaCreativeReuse";

const platform = META;
const grid = {
  xs: 12,
  lg: 6,
};

const CampaignMetaForm = () => {
  const {
    control,
    formState,
    watch,
    setValue,
    isGeneralDisabledFields,
    getIsCampaignPlatformCreated,
    getValues,
    setCurrencyTaxes,
  } = useFormContext();
  useFocusErrorForm(formState);
  const errors = formState.errors;

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const isCampaignPlatformCreated = getIsCampaignPlatformCreated(platform);
  const basicPath = `platformsData.${platform}`;
  const platformData = watch(basicPath) || {};
  const isCatalogCampaign = platformData?.isCatalogCampaign;
  const isIOS14Campaign = platformData?.isIOS14Campaign;
  const isIncompatible = platformData?.isIncompatible;
  const objective = platformData?.objective;
  const typeBudget = platformData?.typeBudget;
  const useCampaignBudget = platformData?.useCampaignBudget || false;
  const buyingType = platformData?.buyingType;

  const adsGroups = watch("adsGroups");
  const hasAdsGroupsWithIGRequired = adsGroups.some(
    (adGroup) =>
      adGroup.platform === META &&
      adGroup.destinationType &&
      ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED.includes(
        adGroup.destinationType
      )
  );

  const { integrations } = useSelectorApp((state) => state.user);
  const hasInstagramAccounts = hasInstagramAccountsConnected(
    integrations,
    platformData?.integrationID,
    platformData?.pageID
  );
  const isInstagramRequired = hasAdsGroupsWithIGRequired;
  const instagramLabel =
    hasInstagramAccounts || isInstagramRequired
      ? t(INSTAGRAM_ACCOUNT_PLACEHOLDER)
      : `${t(INSTAGRAM_ACCOUNT_PLACEHOLDER)} (${t(OPTIONAL)})`;

  const isDisabledFields = isIncompatible || isGeneralDisabledFields;

  const currency = dispatch(
    getCurrencyAdAccountPlatform({
      platform,
      integrationID: platformData?.integrationID,
      adAccountID: platformData?.adAccountID,
    })
  );

  const prevCampaignBudgetRef = useRef(null);

  const onCampaignBudgetBlur = () => {
    const newCampaignBudget = Number(getValues(`${basicPath}.budget`)) || 0;
    const prevCampaignBudget =
      prevCampaignBudgetRef.current ?? newCampaignBudget;
    prevCampaignBudgetRef.current = newCampaignBudget;

    if (prevCampaignBudget <= 0) return;

    const adsGroupsList = getValues("adsGroups") || [];
    adsGroupsList.forEach((adGroup, index) => {
      if (
        adGroup?.platform !== META ||
        adGroup?.budgetLimitsMode !== "percentage"
      ) {
        return;
      }

      const minBudget = Number(adGroup?.minBudget) || 0;
      const maxBudget = Number(adGroup?.maxBudget) || 0;

      const scaledMin =
        minBudget > 0 && prevCampaignBudget > 0
          ? (minBudget / prevCampaignBudget) * newCampaignBudget
          : 0;
      const scaledMax =
        maxBudget > 0 && prevCampaignBudget > 0
          ? (maxBudget / prevCampaignBudget) * newCampaignBudget
          : 0;

      const pctMin =
        newCampaignBudget > 0
          ? clampIntegerMetaBudgetPercent(
              Math.round((scaledMin / newCampaignBudget) * 100)
            )
          : 0;
      const pctMax =
        newCampaignBudget > 0
          ? clampIntegerMetaBudgetPercent(
              Math.round((scaledMax / newCampaignBudget) * 100)
            )
          : 0;

      const newMinBudget =
        minBudget > 0
          ? metaBudgetAmountFromIntegerPercent(
              pctMin,
              newCampaignBudget,
              currency
            )
          : "";
      const newMaxBudget =
        maxBudget > 0
          ? metaBudgetAmountFromIntegerPercent(
              pctMax,
              newCampaignBudget,
              currency
            )
          : "";

      setValue(`adsGroups.[${index}].minBudget`, newMinBudget);
      setValue(`adsGroups.[${index}].maxBudget`, newMaxBudget);
    });
  };

  useEffect(() => {
    if (useCampaignBudget) {
      const budget = getValues(`${basicPath}.budget`);
      if (budget != null && budget !== "") {
        prevCampaignBudgetRef.current = Number(budget) || 0;
      }
    }
    // eslint-disable-next-line
  }, [useCampaignBudget]);

  useEffect(() => {
    if (!buyingType) {
      setValue(
        `${basicPath}.buyingType`,
        ADS_CAMPAIGN_BUYING_TYPE_AUCTION_OPTION
      );
    }
    // eslint-disable-next-line
  }, []);

  const validationChangeObjective = async (newObjective) => {
    const adsGroups = getValues("adsGroups");
    const hasSomeAdGroupWithDestinationTypeOnPost = adsGroups.some(
      (adGroup) =>
        adGroup.platform === META &&
        adGroup.destinationType ===
          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION
    );
    if (
      objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION &&
      hasSomeAdGroupWithDestinationTypeOnPost &&
      newObjective !== objective
    ) {
      const result = await ConfirmAlert({
        title: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE
        ),
        text: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION
        ),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });

      if (!result.isConfirmed) return false;
      onCleanMediaUrls();
    }

    return true;
  };

  const onCleanMediaUrls = () => {
    const adsGroups = getValues("adsGroups");

    adsGroups.forEach((adGroup, index) => {
      if (
        adGroup.platform !== META ||
        adGroup.destinationType !==
          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION
      )
        return;
      const ads = adGroup?.ads || [];

      ads.forEach((ad, indexAd) => {
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaUrls`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaData`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
      });
    });
  };

  const validationChangeBuyingType = async (newBuyingType) => {
    if (newBuyingType === ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION) {
      const result = await ConfirmAlert({
        title: t(CHANGE_BUYING_TYPE_TO_RESERVED_TITLE),
        text: t(CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });

      if (!result.isConfirmed) return false;

      setValue(
        `${basicPath}.objective`,
        ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION
      );
      setValue(`${basicPath}.useCampaignBudget`, false);

      const adsGroups = getValues("adsGroups") || [];
      adsGroups.forEach((adGroup, index) => {
        if (adGroup.platform !== META) return;
        setValue(
          `adsGroups.[${index}].destinationType`,
          ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
        );
        setValue(
          `adsGroups.[${index}].typeBudget`,
          ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION
        );

        const ads = adGroup?.ads || [];
        ads.forEach((ad, indexAd) => {
          setValue(
            `adsGroups.[${index}].ads.[${indexAd}].destinationType`,
            ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
          );
        });
      });

      onClearConfigurationCatalog();
    }

    return true;
  };

  const validationChangeAdAccount = async () => {
    const result = await ConfirmAlert({
      title: t(ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE),
      html: (
        <Typography
          variant="body1"
          sx={{
            fontFamily: FONT_FAMILY,
            "& *": {
              p: "revert",
              m: "revert",
              listStyle: "revert",
              textDecoration: "revert",
            },
          }}
          dangerouslySetInnerHTML={{
            __html: t(ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION),
          }}
        />
      ),
      confirmButtonText: t(BUTTON_CONTINUE),
      cancelButtonText: t(BUTTON_CANCEL),
    });

    if (!result.isConfirmed) return false;

    return true;
  };

  const onClearConfigurationCatalog = ({
    clearCatalogID = true,
    clearIsCatalogCampaign = true,
    clearProductSetID = true,
    destinationType = ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  } = {}) => {
    if (clearCatalogID) setValue(`${basicPath}.catalogID`, "");
    if (clearIsCatalogCampaign)
      setValue(`${basicPath}.isCatalogCampaign`, false);

    if (clearProductSetID) {
      const adsGroups = getValues("adsGroups");
      adsGroups.forEach((adGroup, index) => {
        if (adGroup.platform !== META) return;
        setValue(`adsGroups.[${index}].productSetID`, "");
        setValue(`adsGroups.[${index}].destinationType`, destinationType);
        setValue(`adsGroups.[${index}].trackingCustomEventID`, "");

        const ads = adGroup?.ads || [];
        ads.forEach((ad, indexAd) => {
          setValue(
            `adsGroups.[${index}].ads.[${indexAd}].appConfiguration`,
            {}
          );
          setValue(
            `adsGroups.[${index}].ads.[${indexAd}].destinationType`,
            destinationType
          );
          setValue(`adsGroups.[${index}].ads.[${indexAd}].productSetID`, "");
        });
      });
    }
  };

  const onClearConfigurationIOS14Campaign = ({ value }) => {
    if (!value) {
      setValue(`${basicPath}.appID`, "");
    }

    if (value) {
      onUpdateAdGroupsAppPromotion({
        destinationType: ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
        appID: "",
      });
    }
  };
  const onUpdateCurrencyTaxes = async ({ adAccountID, integrationID }) => {
    const newCurrency = dispatch(
      getCurrencyAdAccountPlatform({
        platform,
        integrationID,
        adAccountID,
      })
    );
    const response = await dispatch(startGetCurrencyTax(newCurrency));
    setCurrencyTaxes((prev) => ({
      ...prev,
      [newCurrency]: response?.ok ? response?.data : 1,
    }));
  };
  const onUpdateAdGroupsAppPromotion = ({ appID, destinationType }) => {
    const adsGroups = getValues("adsGroups");

    adsGroups.forEach((adGroup, index) => {
      if (adGroup.platform !== META) return;

      setValue(`adsGroups.[${index}].appID`, appID);
      if (destinationType) {
        setValue(`adsGroups.[${index}].destinationType`, destinationType);
      }
    });
  };

  const onChangeAdAccount = (value) => {
    setValue(`${basicPath}.integrationID`, value?.integrationID);
    setValue(`${basicPath}.pageID`, "");
    setValue(`${basicPath}.instagramID`, "");

    const isCatalogCampaign = getValues(`${basicPath}.isCatalogCampaign`);

    setValue(`${basicPath}.appID`, "");
    setValue(`${basicPath}.catalogID`, "");
    setValue(`${basicPath}.budget`, "");

    onClearConfigurationCatalog({
      clearIsCatalogCampaign: false,
      destinationType: isCatalogCampaign
        ? ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION
        : ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    });

    const adsGroups = getValues("adsGroups");
    adsGroups.forEach((adGroup, index) => {
      if (adGroup.platform !== META) return;
      setValue(`adsGroups.[${index}].customAudiences`, []);
      setValue(`adsGroups.[${index}].excludedCustomAudiences`, []);
      setValue(`adsGroups.[${index}].trackingID`, "");
      setValue(`adsGroups.[${index}].appID`, "");
      setValue(`adsGroups.[${index}].catalogID`, "");
      setValue(`adsGroups.[${index}].productSetID`, "");
      setValue(`adsGroups.[${index}].trackingCustomEventID`, "");
      setValue(`adsGroups.[${index}].whatsappBusinessNumber`, {});
      setValue(`adsGroups.[${index}].budget`, "");

      const ads = adGroup?.ads || [];
      ads.forEach((ad, indexAd) => {
        setValue(`adsGroups.[${index}].ads.[${indexAd}].instantForm`, {});
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].productSetID`, "");
      });
    });

    clearMetaReusableCreativeModeFromAds({
      getValues,
      setValue,
      platform: META,
    });

    const adAccountID = value?.id;
    const integrationID = value?.integrationID;
    onUpdateCurrencyTaxes({ adAccountID, integrationID });
  };

  const onChangePage = () => {
    setValue(`${basicPath}.useFBPageAsIG`, false);
    setValue(`${basicPath}.instagramID`, "");
    clearMetaReusableCreativeModeFromAds({
      getValues,
      setValue,
      platform: META,
    });
  };

  return (
    <Grid container spacing={3}>
      {!isCampaignPlatformCreated && (
        <Grid item xs={12}>
          <ReasoningContainer platform={platform} />
        </Grid>
      )}

      <Grid item xs={12}>
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={3}>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {t(BUYING_TYPE_PLACEHOLDER)}
              </Typography>
              <Select
                options={optionsBuyingType}
                disabled={isCampaignPlatformCreated || isDisabledFields}
                name={`${basicPath}.buyingType`}
                validationChange={validationChangeBuyingType}
                variant="filled"
                fullWidth
                doTranslate={true}
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {t(ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER)}
              </Typography>
              <AutocompleteField
                name={`${basicPath}.specialAdCategories`}
                control={control}
                errors={errors}
                options={optionsAdsCampaignSpecialAdCategoriesMeta}
                doTranslate={true}
                fullWidth
                multiple={true}
                variant="filled"
                disabled={isDisabledFields}
              />
            </Grid>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {t(OBJECTIVE_PLACEHOLDER)}
              </Typography>
              <Select
                options={optionsAdsCampaignObjectivesMeta}
                disabled={
                  isCampaignPlatformCreated ||
                  isDisabledFields ||
                  buyingType === ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION
                }
                name={`${basicPath}.objective`}
                actionsChange={() => {
                  onClearConfigurationCatalog();

                  const adsGroups = getValues("adsGroups");
                  adsGroups.forEach((adGroup, index) => {
                    if (adGroup.platform !== META) return;
                    setValue(
                      `adsGroups.[${index}].destinationType`,
                      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
                    );

                    const ads = adGroup?.ads || [];
                    ads.forEach((ad, indexAd) => {
                      setValue(
                        `adsGroups.[${index}].ads.[${indexAd}].destinationType`,
                        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
                      );
                    });
                  });
                }}
                validationChange={validationChangeObjective}
                variant="filled"
                fullWidth
                doTranslate={true}
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {t(AD_ACCOUNT_PLATFORMS_LABELS[platform])}
              </Typography>
              <SelectBusinessAccount
                variant="filled"
                disabled={isCampaignPlatformCreated || isDisabledFields}
                control={control}
                platform={platform}
                name={`${basicPath}.adAccountID`}
                onChangeAction={onChangeAdAccount}
                validationChange={validationChangeAdAccount}
                errors={errors}
                fullWidth={true}
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {t(PAGE_FACEBOOK_PLACEHOLDER)}
              </Typography>
              <SelectPageFacebook
                variant="filled"
                disabled={
                  isCampaignPlatformCreated ||
                  !platformData?.adAccountID ||
                  isDisabledFields
                }
                name={`${basicPath}.pageID`}
                onChangeAction={onChangePage}
                integrationID={platformData?.integrationID}
                adAccountID={platformData?.adAccountID}
                control={control}
                platform={platform}
                errors={errors}
                fullWidth={true}
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {instagramLabel}
              </Typography>
              <SelectInstagramAccount
                variant="filled"
                disabled={
                  isCampaignPlatformCreated ||
                  !platformData?.pageID ||
                  isDisabledFields
                }
                name={`${basicPath}.instagramID`}
                integrationID={platformData?.integrationID}
                pageID={platformData?.pageID}
                adAccountID={platformData?.adAccountID}
                nameUseFBPageAsIG={`${basicPath}.useFBPageAsIG`}
                control={control}
                errors={errors}
                platform={platform}
                fullWidth={true}
                isInstagramRequired={isInstagramRequired}
                rules={{
                  required: {
                    value: isInstagramRequired,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>

            {/* Catalog Campaign */}
            {objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION && (
              <Grid item {...grid}>
                <Typography sx={{ mb: 1 }} variant="body1">
                  {t(IS_CATALOG_CAMPAIGN_PLACEHOLDER)}
                </Typography>
                <Controller
                  name={`${basicPath}.isCatalogCampaign`}
                  control={control}
                  render={({ field }) => (
                    <Switch
                      disabled={true}
                      labelActive={ACTIVE}
                      labelDeactivate={DEACTIVATED}
                      isActive={field.value}
                      labelPlacement="end"
                      onChangeIsActive={(value) => {
                        field.onChange(value);

                        onClearConfigurationCatalog({
                          clearIsCatalogCampaign: false,
                          destinationType: value
                            ? ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION
                            : ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
                        });
                      }}
                    />
                  )}
                />
              </Grid>
            )}
            {objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
              isCatalogCampaign && (
                <Grid item {...grid}>
                  <Typography sx={{ mb: 1 }} variant="body1">
                    {t(CATALOG_PLACEHOLDER)}
                  </Typography>
                  <SelectCatalogMeta
                    fullWidth
                    variant="filled"
                    disabled={isCampaignPlatformCreated || isDisabledFields}
                    platform={META}
                    integrationID={platformData?.integrationID}
                    adAccountID={platformData?.adAccountID}
                    control={control}
                    name={`${basicPath}.catalogID`}
                    onChangeAction={() =>
                      onClearConfigurationCatalog({
                        clearCatalogID: false,
                        clearIsCatalogCampaign: false,
                        destinationType:
                          ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
                      })
                    }
                    errors={errors}
                  />
                </Grid>
              )}
          </Grid>
        </CardContainer>
      </Grid>

      <Grid item xs={12}>
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={2}>
            <Grid item {...grid}>
              <Typography sx={{ mb: 1 }} variant="body1">
                {t(USE_CAMPAIGN_BUDGET_PLACEHOLDER)}
              </Typography>
              <Controller
                name={`${basicPath}.useCampaignBudget`}
                control={control}
                render={({ field }) => (
                  <Switch
                    disabled={isCampaignPlatformCreated || isDisabledFields}
                    labelActive={ACTIVE}
                    labelDeactivate={DEACTIVATED}
                    isActive={field.value}
                    labelPlacement="end"
                    onChangeIsActive={(value) => {
                      const adsGroups = getValues("adsGroups");
                      adsGroups.forEach((adGroup, index) => {
                        if (adGroup.platform !== META) return;
                        setValue(`adsGroups.[${index}].budget`, "");
                        setValue(`adsGroups.[${index}].typeBudget`, "");
                      });
                      setValue(`${basicPath}.typeBudget`, "");
                      field.onChange(value);
                    }}
                  />
                )}
              />
            </Grid>
            {useCampaignBudget && (
              <>
                <Grid item {...grid}>
                  <Typography sx={{ mb: 1 }} variant="body1">
                    {t(TYPE_BUDGET_PLACEHOLDER)}
                  </Typography>
                  <Select
                    disabled={isCampaignPlatformCreated || isDisabledFields}
                    name={`${basicPath}.typeBudget`}
                    actionsChange={(value) => {
                      const adsGroups = getValues("adsGroups");
                      adsGroups.forEach((adGroup, index) => {
                        if (adGroup.platform !== META) return;
                        setValue(`adsGroups.[${index}].typeBudget`, value);
                      });
                    }}
                    fullWidth
                    variant="filled"
                    doTranslate={true}
                    options={optionsAdsCampaignTypeBudgets}
                    control={control}
                    errors={errors}
                    rules={{
                      required: {
                        value: true,
                        message: t(FIELD_REQUIRED),
                      },
                    }}
                  />
                </Grid>
                <Grid item {...grid}>
                  <Typography sx={{ mb: 1 }} variant="body1">
                    {t(
                      typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION
                        ? DAILY_BUDGET_PLACEHOLDER
                        : LIFETIME_BUDGET_PLACEHOLDER,
                      {
                        currency: currency.toUpperCase(),
                      }
                    )}
                  </Typography>

                  <TextField
                    name={`${basicPath}.budget`}
                    disabled={isDisabledFields}
                    fullWidth
                    variant="filled"
                    InputProps={{
                      inputComponent: metaCurrenciesWithDecimals.includes(
                        currency
                      )
                        ? NumberDecimalField
                        : NumberField,
                    }}
                    control={control}
                    errors={errors}
                    actionsBlur={onCampaignBudgetBlur}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </CardContainer>
      </Grid>

      {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION && (
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE)}
                </Typography>
              </Box>
            }
          >
            <Grid container spacing={2}>
              {/* IOS 14 Campaign */}
              {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION && (
                <Grid item {...grid}>
                  <Typography sx={{ mb: 1 }} variant="body1">
                    {t(IOS_14_CAMPAIGN_PLACEHOLDER)}
                  </Typography>
                  <Controller
                    name={`${basicPath}.isIOS14Campaign`}
                    control={control}
                    render={({ field }) => (
                      <Switch
                        disabled={isCampaignPlatformCreated || isDisabledFields}
                        labelActive={ACTIVE}
                        labelDeactivate={DEACTIVATED}
                        isActive={field.value}
                        labelPlacement="end"
                        onChangeIsActive={(value) => {
                          field.onChange(value);

                          onClearConfigurationIOS14Campaign({
                            value,
                          });
                        }}
                      />
                    )}
                  />
                </Grid>
              )}
              {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
                isIOS14Campaign && (
                  <Grid item {...grid}>
                    <SelectAdvertisableAppsMeta
                      disabled={isCampaignPlatformCreated || isDisabledFields}
                      platform={META}
                      label={t(APP_PLACEHOLDER)}
                      adAccountID={platformData?.adAccountID}
                      integrationID={platformData?.integrationID}
                      name={`${basicPath}.appID`}
                      fullWidth
                      variant="filled"
                      control={control}
                      errors={errors}
                      onChangeAction={(value) => {
                        onUpdateAdGroupsAppPromotion({
                          appID: value?.id,
                        });
                      }}
                    />
                  </Grid>
                )}
            </Grid>
          </CardContainer>
        </Grid>
      )}
    </Grid>
  );
};

export default CampaignMetaForm;
